import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signUp } from "../../services/auth/auth";
import { AiFillMail } from "react-icons/ai";
import { RiLockPasswordFill } from "react-icons/ri";
import { BsTelephoneFill } from "react-icons/bs";
import { IoIosContact } from "react-icons/io";
import { IconContext } from "react-icons";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./signup.css";
const Signup = () => {
  // const [name, setName] = useState("");
  // const [email, setEmail] = useState("");
  // const [confirmPassword, setconfirmPassword] = useState("");
  // const [phoneNumber, setphoneNumber] = useState("");
  // const [password, setPassword] = useState("");
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      confirmPassword: "",
      phoneNumber: "",
      password: "",
    },
    onSubmit: values => {
      setLoader(true);
      signUp(values)
        .then((res) => {
          console.log("res :", res);
          toast.success("Verification Email Sent To Your Email ", {
            theme: "colored",
          });
          navigate("/signin");
          setLoader(false);
        })
        .catch((e) => {
          console.error(e);
          setLoader(false);
          toast.error("something went wrong", {
            theme: "colored",
          });
        });
    },
    validate: values => {
      let errors = {}
      if (!values.name) {
        errors.name = "Name Required"
      }
      if (!values.email) {
        errors.email = "Email Required"

      } else if (!/^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = "Invalid email format"
      }
      if (!values.confirmPassword) {
        errors.confirmPassword = "Confirm Password Required"
      }
      if (!values.phoneNumber) {
        errors.phoneNumber = "Phone Number Required"
      }
      if (!values.password) {
        errors.password = "Password Required"
      }
      return errors

    }
  })
  // const notify = () => toast.success("Successfully Sign-Up");
  // const navigate = useNavigate();
  // const collectData = async () => {
  //   let payload = {
  //     name,
  //     email,
  //     password,
  //     confirmPassword,
  //     phoneNumber,
  //   };
  //   console.log("paylaod sign up : ", payload);
  //   setLoader(true);


  // };
  // const callSigin = () => {
  //   navigate("/signin");
  // };
  return (
    <div className="container-signup">
      <div className="sigup-row">
        <div className="img-profile-signup"></div>
        <div className="sigup-form">
          <div className="form-signupss">
            <form onSubmit={formik.handleSubmit}>
              <h1 className="signup-register-heading">Register</h1>

              <div className="input-main">

                <div>
                  <IconContext.Provider value={{ size: "20px" }}>
                    {" "}
                    <span className="em">
                      <IoIosContact />
                    </span>
                  </IconContext.Provider>
                  <input
                    className="input-box"
                    type="text"
                    placeholder="Enter Name"
                    id="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />

                  {formik.touched.name && formik.errors.name ? <div className="s">{formik.errors.name}</div> : null}

              </div>
            
<div>
<span className="em">
                <AiFillMail />
              </span>
              <input
                className="input-box"
                type="email"
                id="email"
                placeholder="Enter Email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
           
              {formik.touched.email && formik.errors.email? <div className="s">{formik.errors.email}</div>:null}
              </div>
              <div>
              <span className="em">
                <BsTelephoneFill />
              </span>
              <input
                className="input-box"
                type="text"
                id="phoneNumber"
                placeholder="Enter phone Number"
                value={formik.values.phoneNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
             
              {formik.touched.phoneNumber && formik.errors.phoneNumber ? <div className="s">{formik.errors.phoneNumber}</div>:null}
              </div>
<div>
<span className="em">
                <RiLockPasswordFill />
              </span>
              <input
                className="input-box"
                type="Password"
                id="password"
                placeholder="Enter Password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            
              {formik.touched.password && formik.errors.password? <div className="s">{formik.errors.password}</div> :null}
              </div>
              <div>
              <span className="em">
                <RiLockPasswordFill />
              </span>
              <input
                className="input-box"
                type="password"
                id="confirmPassword"
                placeholder="Enter the Confirm password"
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.confirmPassword && formik.errors.confirmPassword ?<div className="s">{formik.errors.confirmPassword}</div>:null}
            </div>
            </div>
            <div className="subminte-btn-main">
              <button
                disabled={loader}
                className="submite-btn"
                // onClick={() => {
                //   collectData();
                // }}
                type="submit"
              >
                Sign-Up
              </button>
            </div>
            </form>
            <div className="signin__Link">
              <p>
                Already have an account? <Link to="/signin">Sign-In</Link>
              </p>
            </div>
          </div>

          <ToastContainer />
        </div>
      </div>
    </div>
  );
};

export default Signup;
